<script lang="ts">
	import type { Breadcrumb } from "#lib/types/breadcrumb.js";
	interface Props {
		breadcrumbs: Breadcrumb[];
	}

	let { breadcrumbs }: Props = $props();
</script>

{#if breadcrumbs?.length !== 1}
	<nav aria-label="Breadcrumb" class="relative z-1">
		<ol class="list-none flex overflow-x-auto px-$space-edge-x py-1 my-0">
			{#each breadcrumbs as b, i (b)}
				<li class="flex">
					{#if i == breadcrumbs.length - 1}
						<a href={b.href} aria-current="page">{b.label}</a>
					{:else}
						<a href={b.href}>{b.label}</a>
					{/if}
				</li>
			{/each}
		</ol>
	</nav>
{/if}

<style>
	li + li::before {
		width: var(--s-3);
		transform: rotate(15deg);
		background: no-repeat center / 1px 1.75ex linear-gradient(currentColor, currentColor);
		content: "";
		margin-block: calc(var(--s-3) + 0.5px);
	}

	[aria-current="page"] {
		font-weight: 600;
		text-decoration: none;
	}

	li a {
		display: inline-block;
		padding-block: calc(var(--s-3) + 0.5px);
		white-space: nowrap;
	}
</style>
